import { Branding, DisabledPrompt, NavLink, useModel } from "@bcm-dev/bcms-vite";
import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle } from 'compid/custom-ui/CustomAccordion';
import React from 'react';
import { SVGAsset } from 'res';
import './styles.css';

/**
 * @function VerticalMenuView
 * @param {String} className - Allows us to set a custom class name for the component
 * @return {React.Component}
 * @exported true
 * @description The Vertical Menu
 */

export default function VerticalMenuView(props) {
  const className = props.className ?? "";
  const model = useModel();
  const { options } = model.branding;
  const hasZelle = options.zle_rpx22 === "true" ? true : false;

  return (
    <div className="vertical-menu-view nav-container">
      <div className="nav-view flex-container flex-vertical">
        <NavLink to="/PayBills" activeClassName="active-item" activeRoutes={["/PayBills"]} className="nav-link nav-item">
          <span data-point="Main_Menu_Pay_Bills">PAY BILLS</span>
        </NavLink>
        <NavLink to="/activity" activeClassName="active-item" activeRoutes={["/Activity", "/Activity/:billerID"]} className="nav-link nav-item" dataPoint="Activity_Tab">
          <span>ACTIVITY</span>
        </NavLink>
        {hasZelle &&
          <NavLink to="/zelle" activeClassName="active-item" activeRoutes={["/zelle"]} className="nav-link nav-item zelle-item">
            <div className="zelle-container">
              <SVGAsset id="ZelleLogo" className="zelle-logo" data-point="Zelle_Tab" />
            </div>
          </NavLink>
        }
        <DisabledPrompt>
          <NavLink activeClassName="active-item" className="nav-link nav-item" dataPoint="messageIcon">
            <span>MESSAGES</span>
          </NavLink>
        </DisabledPrompt>
        <Branding id="help_guide_rxp22" value="true">
          <CustomAccordion className="set-width justify-right help-guide-accordion">
            <CustomAccordionToggle className="flex-container all-center">
              <NavLink activeClassName="active-item" className="nav-link nav-item">
                <div className="flex-container flex-horizontal align-center">
                  <span className="set-width">HELP</span>
                  <SVGAsset id="DownChevronIcon" className="chevron-down-icon right-icon" />
                </div>
              </NavLink>
            </CustomAccordionToggle>
            <CustomAccordionContent>
              <div className="help-guide-menu">
                <DisabledPrompt>
                  <div className="help-item clickable">
                    <p>Add biller</p>
                  </div>
                </DisabledPrompt>
                <DisabledPrompt>
                  <div className="help-item clickable">
                    <p>Edit biller</p>
                  </div>
                </DisabledPrompt>
                <DisabledPrompt>
                  <div className="help-item clickable">
                    <p>Edit payment</p>
                  </div>
                </DisabledPrompt>
                <DisabledPrompt>
                  <div className="help-item clickable">
                    <p>Make multiple payments</p>
                  </div>
                </DisabledPrompt>
              </div>
            </CustomAccordionContent>
          </CustomAccordion>
        </Branding>
        <Branding id="help_guide_rxp22" value="false">
          <DisabledPrompt>
            <NavLink activeClassName="active-item" className="nav-link nav-item">
              <div className="flex-container flex-horizontal align-center">
                <span className="set-width">HELP</span>
                <SVGAsset id="DownChevronIcon" className="chevron-down-icon right-icon" />
              </div>
            </NavLink>
          </DisabledPrompt>
        </Branding>
      </div>
    </div>
  );
}